import { createContext } from "react";
const VideoProvider = createContext();
export default VideoProvider;

